import React from 'react';

const Icon = ({ size = '20', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" {...other}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.751 14.909c.71-.088 1.837-.034 2.06.256.168.22-.006 1.213-.292 1.923-.288.707-.717 1.207-.954 1.4-.24.193-.417.118-.289-.171.133-.29.857-2.087.57-2.464-.266-.349-1.473-.223-2.033-.164l-.114.012c-.118.01-.214.021-.29.03-.242.027-.307.034-.343-.04-.092-.262.974-.697 1.685-.782Zm-16.761.29c3.29 2.011 8.382 5.124 16.498 1.251.35-.146.594.098.248.541-.348.447-3.134 3.01-7.816 3.01-4.679 0-8.264-3.206-9.357-4.536-.3-.345.045-.501.248-.375l.179.11Z"
                fill="#FF9900"
            />

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.58 14.906a.552.552 0 0 1-.625.063c-.739-.614-.966-.951-1.308-1.458l-.21-.307c-1.45 1.482-2.476 1.925-4.358 1.925-2.225 0-3.958-1.373-3.958-4.125 0-2.149 1.164-3.612 2.82-4.327 1.203-.531 2.807-.695 4.197-.838.268-.027.528-.054.775-.082v-.343l.001-.197c.005-.583.01-1.232-.32-1.72-.324-.488-.942-.69-1.485-.69-1.008 0-1.908.518-2.127 1.59-.045.24-.22.474-.458.485l-2.566-.276c-.216-.048-.454-.223-.394-.555C5.155.938 7.964 0 10.477 0c1.287 0 2.969.343 3.984 1.318 1.183 1.106 1.175 2.551 1.166 4.134l-.002.42v4.126c0 1.107.41 1.66.841 2.242l.156.212c.171.239.208.525-.007.704-.54.45-1.5 1.288-2.027 1.758l-.008-.008Zm-2.667-6.312V7.88c-1.912 0-3.931.41-3.931 2.666 0 1.143.591 1.918 1.607 1.918.743 0 1.41-.459 1.83-1.203.496-.874.495-1.698.494-2.667Z"
                fill="white"
            />
        </svg>
    );
};
export default React.memo(Icon);
